var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ABB Bar / Icon / Admin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 18.19L20.25 17.44L19.5 16.68C19.2999 16.4799 19.1313 16.2506 19 16V9.81001C18.9793 8.21665 18.4054 6.68004 17.3765 5.46324C16.3476 4.24645 14.9278 3.42517 13.36 3.14C13.4664 2.91143 13.5134 2.65973 13.4967 2.40817C13.4801 2.15662 13.4003 1.91331 13.2647 1.70075C13.1292 1.48818 12.9423 1.3132 12.7212 1.19199C12.5001 1.07078 12.2521 1.00723 12 1.00723C11.7479 1.00723 11.4999 1.07078 11.2788 1.19199C11.0577 1.3132 10.8708 1.48818 10.7353 1.70075C10.5997 1.91331 10.5199 2.15662 10.5033 2.40817C10.4866 2.65973 10.5336 2.91143 10.64 3.14C9.07224 3.42517 7.65236 4.24645 6.62347 5.46324C5.59458 6.68004 5.02067 8.21665 5 9.81001V16C4.86865 16.2506 4.70007 16.4799 4.5 16.68L3.75 17.44L3 18.19V21.08H10C10 21.6104 10.2107 22.1191 10.5858 22.4942C10.9609 22.8693 11.4696 23.08 12 23.08C12.5304 23.08 13.0391 22.8693 13.4142 22.4942C13.7893 22.1191 14 21.6104 14 21.08H21V18.19Z",
    fill: "#0F0F0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_icon.b8b2a92ae86566ff8cc3e0b9b0f92684.svg";
export { ForwardRef as ReactComponent };